import { render, staticRenderFns } from "./MeasurementSelection.vue?vue&type=template&id=009a2436&scoped=true"
import script from "./MeasurementSelection.vue?vue&type=script&lang=ts"
export * from "./MeasurementSelection.vue?vue&type=script&lang=ts"
import style0 from "./MeasurementSelection.vue?vue&type=style&index=0&id=009a2436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009a2436",
  null
  
)

export default component.exports